
angular.module('clientDashboardApp.reviewBuilder').factory('campaignManagerService', function($rootScope, $http, $q) {
  return new campaignManagerService($rootScope, $http, $q);
})

class campaignManagerService {

  constructor($rootScope, $http, $q) {
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$q = $q;

    this.campaignListDataPromise = null;
    this.campaignListData = null;
  }

  /**
   * Get a promise of an array of all the campaigns which the current user has access to.
   * @returns {Promise.<Object>}
   */
  listCampaigns() {
    if (this.campaignListDataPromise !== null) {
      return this.campaignListDataPromise;
    } else if (this.campaignListData === null) {
      return this.campaignListDataPromise = this.$http.get('/v5/reviewBuilder/campaign/get').then(resp => {
        this.campaignListDataPromise = null;
        return this.campaignListData = resp.data;
      });
    } else {
      return this.$q.when(this.campaignListData);
    }
  }

  /**
   * Search through the available campaigns, based on filters
   * @param filters - An object containing filters to add.  Available filters are:
   *   - searchTextOpt: String to match against the campaign name
   *   - cursorOpt:     How many records to skip past
   *   - limitOpt:      How many records to return
   *   - accountId:     The ID of an account to filter by that account
   * @returns {Promise.<Object>} Promise of an object containing {count, campaigns}
   */
  searchCampaigns(filters) {
    return this.$http.get('/v5/reviewBuilder/campaign', {params: filters}).then(response => response.data);
  }

  /**
   * Fetch a campaign by ID
   * @param id
   * @returns {Promise.<Object>} Promise of a campaign
   */
  getCampaign(id) {
    return this.$http.get('/v5/reviewBuilder/campaign/get/' + id).then(response => response.data)
  }

  /**
   * Get metadata of a list of campaigns
   * @param campaignIds  An array of campaign IDs to fetch data for
   * @returns {Promise.<Object>} Promise of an object, with metadata keyed by campaign ID
   */
  getCampaignMeta(campaignIds) {
    return this.$http.post('/v5/reviewBuilder/campaign/meta', {campaignIds}).then(response => response.data);
  }

  /**
   * Save a campaign to the persistence layer
   * @param campaign
   * @returns {Promise.<Object>} Promise of the saved campaign
   */
  saveCampaign(campaign) {
    let isCreating = typeof campaign._id === "undefined"

    if (isCreating) {
      return this.$http.post('/v5/reviewBuilder/campaign/create', campaign).then(response => {
        this.$rootScope.$broadcast('campaignCreated', response.data);
        this.campaignListData = null;
        return response.data
      })
    } else {
      return this.$http.put('/v5/reviewBuilder/campaign/' + encodeURIComponent(campaign._id.$oid), campaign).then(response => {
        this.$rootScope.$broadcast("campaignUpdated", response.data);
        this.campaignListData = null;
        return response.data;
      });
    }
  }

  /**
   * Save a campaign which is still being created
   * @param campaign
   * @returns {Promise.<Object>} - The campaign
     */
  savePartialCampaign(campaign) {
    campaign.deleted = true;
    return this.$http.post('/v5/reviewBuilder/campaign/create', campaign).then(response => {
      return response.data
    });
  }

  /**
   * Mark a partial campaign as completed
   * @param campaign
   * @returns {Promise.<Object>}
     */
  finalizePartialCampaign(campaign) {
    let wasFinalized = campaign.deleted === false;
    campaign.deleted = false;
    return this.saveCampaign(campaign).then(result => {
      if (!wasFinalized) {
        this.campaignListData = null;
        this.$rootScope.$broadcast('campaignCreated', campaign);
      }
      return result;
    });
  }


  /**
   * Delete a campaign
   * @param campaign
   * @param deleteReviews
   * @returns Promise.<null> Will be resolved when the campaign is deleted
   */
  deleteCampaign(campaign, deleteReviews) {
    return this.$http.delete(`/v5/reviewBuilder/campaign/delete/${campaign._id.$oid}`, {params: {deleteReviews:deleteReviews}})
      .then(() => {
        this.campaignListData = null;
        this.$rootScope.$broadcast("campaignDeleted", campaign);
      });
  }

}

